export {
    TextBox,
    TextBoxRoot,
    BigTitle as TextBoxBigTitle,
    BiggerTitle as TextBoxBiggerTitle,
    Caption as TextBoxCaption,
    Label as TextBoxLabel,
    SubTitle as TextBoxSubTitle,
    Title as TextBoxTitle,
} from './TextBox';
export type { TextPttrnProps } from './TextBox';
